import { useLocation } from 'react-router-dom'
import { PageChrome, ROUTES, useIsDesktop, type NavKey } from '@/components/gg/chrome'
import { Newsletter } from '@/pages/Newsletter'

const SUB: [string, NavKey, string][] = [
  [ROUTES.newsletterSponsors, 'newsletter.sponsors', 'Sponsor desk'],
  [ROUTES.newsletterBrand, 'newsletter.brand', 'Brand studio'],
  [ROUTES.newsletterConnect, 'newsletter.list', 'Your list'],
]

/**
 * Newsletter (/app/newsletter/*: the gallery and builder, /sponsors, /brand,
 * /connect). The existing builder, under the new chrome.
 *
 * PORT TARGET: Brian's after/newsletter.html (desktop) with the send checklist
 * (sendGate) and after/nl-phone.html on the phone ("best on a computer").
 */
/** Brian's crumb: "Newsletter › Your newsletter", or the family being built. */
function crumb(pathname: string) {
  const f = /\/build\/(letter|magazine|bulletin)/.exec(pathname)?.[1]
  return f ? `The ${f[0].toUpperCase()}${f.slice(1)}` : 'Your newsletter'
}

export function NewsletterPage() {
  const { pathname } = useLocation()
  const sub = SUB.find(([p]) => pathname.startsWith(p))
  // nl-phone.html: on the phone it is "‹ Settings" and Newsletter
  const desktop = useIsDesktop()
  return (
    <>
      <PageChrome
        title={!desktop ? 'Newsletter' : sub ? sub[2] : crumb(pathname)}
        navKey={sub ? sub[1] : 'newsletter.issue'}
        back={{ to: ROUTES.settings, label: 'Settings' }}
      />
      <Newsletter />
    </>
  )
}
